import { EyeIcon } from '@heroicons/react/24/solid'
import { Input, Select, Toggle } from "@/components/ui"
import { locationFormRules } from './locationsSlice'
import { useLocationForm } from './LocationFormContext'
import { typeLocationOptions } from "./options"

const Values = () => {
  const { control, hasError, getErrorMessage, getValues, watch } = useLocationForm()

  const premierLoyerRecu = watch("premier_loyer_recu")
  const fraisEntreeRecu = watch("frais_entree_recu")
  const depotGarantieRecu = watch("depot_garantie_recu")

  return (<>
      <div className='flex flex-col space-y-1'>
        <Select.Form control={control} 
          rules={locationFormRules(getValues).type_location}
          validator={{hasError, getErrorMessage}}
          name='type_location' label="Type de location" 
          options={typeLocationOptions}
        />
      </div>

      <div className="w-full flex flex-wrap justify-between items-center pr-6">
        <div className='flex flex-col space-y-1 w-80'>
          <Input.Currency
            name={"montant_premier_loyer_prorata"}
            control={control}
            label={"Prorata 1er Loyer"}
            disabled={premierLoyerRecu}
            validator={{hasError, getErrorMessage}}
          />
        </div>
        <Toggle.Form
          name={"premier_loyer_recu"}
          control={control}
          label={"Reçu"}
        />
      </div>

      <div className="w-full flex flex-wrap justify-between items-center pr-6">
        <div className='flex flex-col space-y-1 w-80'>
          <Input.Currency
            name={"montant_frais_entree"}
            control={control}
            label={"Frais d'entrée"}
            disabled={fraisEntreeRecu}
            validator={{hasError, getErrorMessage}}
          />
        </div>
        <Toggle.Form
          name={"frais_entree_recu"}
          control={control}
          label={"Reçu"}
        />
      </div>

      <div className="w-full flex flex-wrap justify-between items-center pr-6">
        <div className='flex flex-col space-y-1 w-80'>
          <Input.Currency
            name={"montant_depot_garantie"}
            control={control}
            label={"Dépôt de garantie"}
            disabled={depotGarantieRecu}
            validator={{hasError, getErrorMessage}}
          />
        </div>
        <Toggle.Form
          name={"depot_garantie_recu"}
          control={control}
          label={"Reçu"}
        />
      </div>

      <div className='flex flex-col space-y-1'>
        <Input.Date 
          name={"date_effet_bail"}
          control={control}
          label={"Date d'effet du bail"}
          validator={{hasError, getErrorMessage}}
        />
      </div>
      <div className='flex flex-col space-y-1'>
        <Input.Date 
          name={"date_etat_lieux_entree"}
          control={control}
          label={"Date état des lieux"}
          validator={{hasError, getErrorMessage}}
        />
      </div>
      <Input.Text
        name={"irl"}
        control={control}
        label={"IRL"}
      />
    </>
  )
}

const Files = () => {
  const { location, control } = useLocationForm()

  const handleDownload = (file) => {
    window.open(location[file].url, '_blank')
  }

  return (<>
    <div className="flex justify-between items-start pr-6">
      <Input.File control={control}
        name="bail_file"
        label="Bail"
        defaultValue={location.bail_file ? "Modifier le fichier" : ""}
        inputProps={{accept: [".pdf"]}}
        className="max-w-[350px]"
        canDelete={true}
      />
      { location.bail_file && (
        <button 
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            handleDownload("bail_file")
          }}
          className="btn btn-sm btn-ghost btn-square p-1 hover:bg-primary-400"
          title={`Voir le bail`} aria-label={`Voir le bail`}
        >
          <EyeIcon/>
        </button>
      )}
    </div>

    <div className="flex justify-between items-start pr-6">
      <Input.File control={control}
        name="etat_lieux_entree_file"
        label="Etat des lieux"
        defaultValue={location.etat_lieux_entree_file ? "Modifier le fichier" : ""}
        inputProps={{accept: [".pdf"]}}
        className="max-w-[350px]"
        canDelete={true}
      />
      { location.etat_lieux_entree_file && (
        <button 
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            handleDownload("etat_lieux_entree_file")
          }}
          className="btn btn-sm btn-ghost btn-square p-1 hover:bg-primary-400"
          title={`Voir l'état des lieux entrée`} aria-label={`Voir l'état des lieux entrée`}
        >
          <EyeIcon/>
        </button>
      )}

    </div>
  </>)
}

export default { Values, Files }